export const stringifyOnClient = (args?: object | undefined) => (
  global.__SERVER__ === true ? args : args && JSON.stringify(args)
)